import Speech from 'speak-tts'

export const setVoice = ({ commit, state }, name) => {
  state.speechInstance.setVoice(name)
}

export const pause = ({ commit, state }) => {
  state.speechInstance.pause()
}

export const resume = ({ commit, state }) => {
  state.speechInstance.resume()
}

export const stop = ({ commit, state }) => {
  state.speechInstance.cancel()
}

export const read = ({ commit, state }, string) => {
  const text = string.trim()
  return new Promise((resolve, reject) => {
    const next = () => {
      state.speechInstance.speak({
        text,
        queue: false, // current speech will be interrupted,
        listeners: {
          onstart: e => {
            commit('setCurrentText', e.target.text)
            commit('startReading')
          },
          onend: e => {
            const textRead = e.target.text
            const hasMoreToRead = state.currentIndex < state.playlist.length - 1
            const isReading = state.currentIndex > -1
            const isLastPaylistItem = state.currentIndex === state.playlist.length - 1
            if (text.endsWith(textRead) && hasMoreToRead && isReading) {
              const nextTrack = state.currentIndex + 1
              commit('setCurrentIndex', nextTrack)
              read({ commit, state }, state.playlist[nextTrack].text)
            }
            if (text.endsWith(textRead) && isLastPaylistItem && isReading) {
              commit('endReading')
              commit('setCurrentText', '')
              commit('setCurrentIndex', -1)
            }
          },
          onpause: () => {
            commit('pauseReading')
          },
          onresume: () => {
            commit('resumeReading')
          }
        }
      }).then(() => {
        resolve(true)
      }).catch(e => {
        reject(e)
      })
    }
    if (!state.speechInstance) {
      initializeSpeech({ commit }).then(() => {
        next()
      })
    } else next()
  })
}

export const initializeSpeech = ({ commit }) => {
  return new Promise((resolve, reject) => {
    const speech = new Speech()
    if (speech && speech.hasBrowserSupport()) {
      speech.init().then(data => {
        commit('setAvailableVoices', data.voices)
        commit('setSpeechInstance', speech)
        resolve(speech)
      }).catch(e => {
        // console.log('Fail init speech', e)
        reject(e)
      })
    } else if (window.TTS) {
      window.TTS.checkLanguage().then(list => {
        // Create fake speechInstance
        var ttsSpeechInstance = {
          _speak: false,
          _voice: 'fr-FR',
          _listeners: null,
          _text: '',
          hasBrowserSupport: function () {
            return false
          },
          setVoice: function (voice) {
            this._voice = voice
          },
          pause: function () {
            // WIP : To work
            this.cancel()
          },
          speak: function (params) {
            this._speak = true
            this._listeners = params.listeners
            this._text = params.text

            this._listeners.onstart({
              target: {
                text: this._text
              }
            })
            window.TTS.speak({
              text: this._text,
              locale: this._voice
            }).then(() => {
              this._speak = false
              this._listeners.onend({
                target: {
                  text: this._text
                }
              })
            })
          },
          speaking: function () {
            return this._speak
          },
          cancel: function () {
            window.TTS.stop()
          }
        }

        const languageArr = list.replace(/_/g, '-').split(',')
        commit('setAvailableVoices', languageArr)
        commit('setSpeechInstance', ttsSpeechInstance)

        resolve(ttsSpeechInstance)
      }).catch(e => {
        reject(e)
      })
    }
  })
}

export const startMarkerPlaylist = ({ commit, state }, payload) => {
  if (state.setSpeechInstance && state.setSpeechInstance.speaking()) {
    commit('setCurrentIndex', -1)
    state.speechInstance.cancel()
  }
  const i = payload.i || 0
  return new Promise((resolve, reject) => {
    commit('setMarkerSpeech', payload.marker)
    commit('setPlaylist', payload.playlist)
    commit('setCurrentIndex', i)
    if (payload.playlist[i] && payload.playlist[i].text) {
      read({ commit, state }, payload.playlist[i].text).then(() => {
        resolve()
      })
    } else {
      resolve()
    }
  })
}

export const stopCurrentPlaylist = ({ commit, state }, payload) => {
  commit('setMarkerSpeech', null)
  commit('setPlaylist', [])
  commit('setCurrentIndex', -1)
  if (state.speechInstance.speaking()) state.speechInstance.cancel()
}

export const playTrackByIndex = ({ commit, state }, n) => {
  if (n < (state.playlist.length)) {
    const text = state.playlist[n].text
    if (text) {
      if (state.speechInstance.speaking()) {
        // make sur it wont autoplay
        commit('setCurrentIndex', -1)
        state.speechInstance.cancel()
        // onEnd is fired with currentIndex of -1
        // this hack kills the autoplay bug
        setTimeout(() => {
          commit('setCurrentIndex', n)
          read({ commit, state }, text)
        }, 50)
      } else {
        commit('setCurrentIndex', n)
        read({ commit, state }, text)
      }
    }
  }
}

export const setMarkerSpeech = ({ commit }, marker) => {
  commit('setMarkerSpeech', marker)
}
